import $ from 'jquery';
import mapboxgl from 'mapbox-gl';

if ($('.mapbox-wrapper').length) {
  $('.mapbox-wrapper').each(function (index) {
    $(this).attr('id', 'mapboxWrapper--' + index);
    const marker = $(this);

    if (marker.attr('data-lng')) {
      var markerPosition = new mapboxgl.LngLat(
        marker.attr('data-lng'),
        marker.attr('data-lat')
      );

      mapboxgl.accessToken = 'pk.eyJ1IjoiYmxhY2tkZXNrIiwiYSI6ImNsaHl4MGZjNzB6ZjQzbXJ1YmhzdmJiZ3EifQ.p-m6xd1-x4I5BIwgH9bnfQ';
      var map = new mapboxgl.Map({
        container: $(this).attr('id'),
        style: 'mapbox://styles/blackdesk/clhyx0n5202ao01pnacabanvt',
        attributionControl: false,
        center: markerPosition,
        maxZoom: 18,
        minZoom: 6,
        zoom: 7,
      });

      map.addControl(new mapboxgl.NavigationControl());

      var markers = [];
      var lat = [];
      var lng = [];

      $('div#mapbox-marker', this).each(function () {
        var markerll = new mapboxgl.LngLat(
          $(this).attr('data-lng'),
          $(this).attr('data-lat')
        );
        var lati = $(this).attr('data-lat');
        var lngi = $(this).attr('data-lng');
        lat.push(lati);
        lng.push(lngi);

        // add marker to map
        var el = document.createElement('div');
        el.className = 'marker-custom';
        el.style.backgroundImage =
          'url(/wp-content/themes/edwautolease/public/images/marker.svg)';

        new mapboxgl.Marker(el).setLngLat(markerll).addTo(map);
        //Push the marker into the markers array
        markers.push(el);

        //Make the popup and get the data.object
        var contentpopup = $(this).html();

        //Display popup onclick
        $(el).on('click', function (e) {
          $('.mapboxgl-popup').hide();
          e.stopPropagation();
          new mapboxgl.Popup()
            .setLngLat(markerll)
            .setHTML(contentpopup)
            .addTo(map);
        });
      });
    }

    $(function () {
      if (map) {
        map.scrollZoom.disable();
        map.on('load', function () {
          map.resize();
        });
      }
    });
  });
}

$(document).on('mouseup', function(e){
  if($('.mapboxgl-popup').is(':visible')){
    var container = $('.mapboxgl-popup');
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $('.mapboxgl-popup').hide();
    } 
  }
});
